'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var arrays = require('./arrays.js');
var math = require('./math.js');
var functional = require('./functional.js');
var files = require('./files.js');
var text = require('./text.js');



exports.simpleRange = arrays.simpleRange;
exports.minMax = math.minMax;
exports.safeDivide = math.safeDivide;
exports.compose = functional.compose;
exports.pipe = functional.pipe;
exports.bytesToSize = files.bytesToSize;
exports.getFileExtension = files.getFileExtension;
exports.sizeToBytes = files.sizeToBytes;
exports.titleCase = text.titleCase;
